import React from "react";
import "./InsightsTab.scss";

type Insight = {
    question: string;
    text: string;
    setText: (text: string) => void;
};

type Props = {
    insights: Insight[];
};

const InsightsTab: React.FC<Props> = ({ insights }) => {
    return (
        <div className="feedback__insights__tab">
            <h6>Step 2: Insights</h6>
            <div className="devider"></div>
            {insights.map((insight, idx) => (
                <div key={idx} className="feedback__review">
                    <div className="review__question">
                        <p>{insight.question}</p>
                        {/* <p style={{ color: "#ccc" }}>Max. 50 words</p> */}
                    </div>
                    <textarea
                        style={{ marginBottom: 12 }}
                        value={insight.text}
                        onChange={(event) => {
                            insight.setText(event.target.value);
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default InsightsTab;
